<template>
    <div class="ku-place">
        <div class="order" v-if="list.length > 0">
            <div class="sp">取餐号</div>
            <div class="s1">
                <div class="c1" v-for="(v, i) in list" :key="i" @click="onShow(v)">
                    <span>{{ v.createtime }}</span>
                    <label>{{ v.order_no }}</label>
                </div>
                <div class="c2">上传成功，美味稍等</div>
                <van-button type="info" round @click="shop(1)">继续点餐</van-button>
            </div>
        </div>

        <div class="top" v-else>
            <!--div class="br">
                <van-field v-model="order_no" @focus="inFocus" placeholder="上传单号" />
                <van-button type="info" @click="seat">确定</van-button>
            </div>
            <div class="bc" v-show="!countFlag">{{ countNum }}秒后自动跳转</div-->
        </div>

        <van-popup v-model="show" closeable close-icon="close">
            <div class="order-info">
                <van-row>
                    <van-col class="s1 bor" span="24">
                        <span class="c0">{{ info.order_no }}</span>
                        <span class="c1" v-if="info.pack === 1">堂食</span>
                        <span class="c1" v-if="info.pack === 2">外带</span>
                        <span class="c1" v-if="info.pack === 3">外卖</span>
                    </van-col>
                    <!-- 配送信息 -->
                    <van-col class="s2 bor" span="24" v-show="info.pack === 3">
                        <span>{{ info.address }} {{ info.name }}</span>
                        <span>{{ info.mobile }}</span>
                    </van-col>
                    <!-- 备注 -->
                    <van-col class="s3 bor pd" span="24" v-show="info.remarks !== ''">{{ info.remarks }}</van-col>
                    <!-- 餐品 -->
                    <van-col class="s4 bor" span="24">
                        <van-row class="c1" v-for="(vo, i) in info.goods" :key="i">
                            <van-col class="g1" span="4">{{ vo.num }}</van-col>
                            <van-col class="g2" span="15">{{ vo.goods_name }}</van-col>
                            <van-col class="g3" span="5">{{ vo.price }}元</van-col>
                            <van-col class="g4" span="24" v-for="(ve, ie) in vo.raise" :key="ie">
                                <van-col span="4"></van-col>
                                <van-col span="14">*{{ ve.name }}</van-col>
                            </van-col>
                        </van-row>
                        <van-row class="c1 pdt" v-show="info.packing_num > 0">
                            <van-col class="g1" span="4">{{ info.packing_num }}</van-col>
                            <van-col class="g2" span="15">包装费</van-col>
                            <van-col class="g3" span="5">{{ info.packing_price }}元</van-col>
                        </van-row>
                        <van-row class="c1" v-show="info.tableware_num > 0">
                            <van-col class="g1" span="4">{{ info.tableware_num }}</van-col>
                            <van-col class="g2" span="15">餐具</van-col>
                            <van-col class="g3" span="5">{{ info.tableware_price }}元</van-col>
                        </van-row>
                        <van-row class="c1" v-show="info.pack === 3">
                            <van-col class="g1" span="4"></van-col>
                            <van-col class="g2" span="15">外送费</van-col>
                            <van-col class="g3" span="5">{{ info.delivery_price }}元</van-col>
                        </van-row>
                    </van-col>
                    <!-- 餐品 -->
                    <van-col class="s5 bor" span="24">总计： {{ info.price }}元</van-col>
                    <van-col class="s6 bor" span="24" v-if="info.shop">{{ info.shop.shop_name }} {{ info.shop.address }} <br />{{ info.createtime }}</van-col>
                    <van-col class="s7" span="24">饿的神-更懂餐饮的好系统</van-col>
                </van-row>
            </div>
        </van-popup>

    </div>
</template>

<script>
    import Vue from 'vue';
    import {Field, Button, Dialog, Image as VanImage, Popup, Col, Row} from 'vant';
    import {getCookie, setCookie} from '@/utils/auth'

    Vue.use(Field).use(Button).use(Dialog).use(VanImage).use(Popup).use(Col).use(Row);
    export default {
        name: "index",
        data() {
            return {
                order_no: '',
                show: false,
                number: 1,
                shop_id: '',
                loading: false,
                finished: false,
                page: 1,

                checkTime: false,
                // 倒计时周期
                countNum: 2,
                // 用于倒计时标记，true-正在倒计时
                countFlag: false,
                list: [],
                info: {},
            }
        },
        mounted() {
            this.address = getCookie('address')
            this.shop_id = getCookie('shopId')
            this.number  = getCookie('shop_number_' + this.shop_id)
            this.onLoad()
        },
        methods: {
            shop(type) {
                setCookie('coType', type)
                this.$router.push({
                    path: this.checkTime ? 'goods_fast' : 'goods',
                    query: {
                        shop_id: this.shop_id
                    }
                })
            },
            onLoad() {
                let that = this
                this.$API.getShopInfo({shop_id: that.shop_id}).then(res => {
                    return res.data
                }).then(res => {
                    that.checkTime = res.data.checkTime
                });

                this.$API.orderSetList({
                    status: that.status,
                    shop_id: that.shop_id,
                    page: 1,
                    limit: 20,
                    number: that.number
                }).then(res => {
                    return res.data;
                }).then(res => {
                    this.loading = false;
                    let data = res.data
                    if (res.data.length === 0) {
                        this.countFlag = false;
                        this.countDown();
                    } else {
                        data.forEach(function (item) {
                            item.goods.forEach(function (vo) {
                                if (vo.raise) {
                                    let arr = vo.raise.split(',')
                                    let raise = [];
                                    arr.forEach(function (ve, ke) {
                                        let ars = ve.split('‡')
                                        raise[ke] = {
                                            id: ars[0],
                                            name: ars[1],
                                            price: ars[2],
                                        }
                                    });
                                    vo.raise = raise
                                }
                                console.log(vo)
                            })
                            that.list.push(item);
                        })
                    }
                });
            },
            seat() {
                let that = this
                if (that.number == '' || that.order_no == '') {
                    that.shop(1);
                    return false;
                }
                this.$API.orderSendSeat({
                    shop_id: that.shop_id,
                    number: that.number,
                    order_no: that.order_no
                }).then(res => {
                    if (res.data.code === 1) {
                        that.number = ''
                        Dialog.alert({
                            message: '上传成功',
                        })
                    }
                })
            },
            // 倒计时
            countDown () {
                this.shop(1)
                // 设置倒计时
                // this.intervalBtn = setInterval(() => {
                //     if (this.countNum <= 1 || this.countFlag === true) {
                //         // 清除定时器
                //         clearInterval(this.intervalBtn)
                //         // 更改btn状态
                //         this.countFlag = true
                //         if (this.countNum <= 1) {
                //             console.log('跳转页面')
                //             this.shop(1)
                //         }
                //     } else {
                //         // 倒计时
                //         this.countNum--
                //     }
                // }, 1000)
            },
            inFocus () {
                this.countFlag = true
            },
            onShow(val) {
                this.info = val
                this.show = true
            },
        },
    }
</script>

<style lang="less" scoped>
.order-info {
    width: 600px;
    padding: 20px 30px 50px 30px;
    min-height: 300px;
    .s1 {
        position: relative;
        .c0 {
            font-size: 110px;
            color: #000;
            font-weight: bold;
        }
        .c1 {
            position: absolute;
            right: 10px;
            bottom: 5px;
            font-size: 26px;
        }
        padding: 15px 0;
    }
    .bor {
        border-bottom: 1px dashed #666;
    }
    .pdt {
        padding-top: 20px;
    }
    .pd {
        padding: 20px;
    }
    .s2 {
        padding: 20px;
        span {
            display: block;
            height: 45px;
            line-height: 45px;
            font-size: 28px;
            text-align: left;
        }
    }
    .s3 {

    }
    .s4 {
        padding: 20px 10px;
        .c1 {
            text-align: left;
            font-size: 26px;
            line-height: 40px;
            .g3 {
                text-align: right;
            }
        }
    }
    .s5 {
        padding: 15px 10px;
        font-size: 28px;
        text-align: right;
    }
    .s6 {
        padding: 15px 0;
        font-size: 28px;
        line-height: 40px;
    }
    .s7 {
        padding: 10px 0;
        font-size: 28px;
    }
}
.ku-place {
    height: 100%;
    width: 100%;
    position: fixed;
    background: #009C90;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    .order {
        margin: auto;
        .sp {
            font-size: 80px;
            font-weight: bold;
            color: #000;
            margin-bottom: 30px;
        }
        .s1 {
            color: #fff;
            .c1 {
                display: flex;
                flex-direction: column;
                margin-bottom: 20px;
                span {
                    font-size: 30px;
                }
                label {
                    font-size: 200px;
                    font-weight: bold;
                    line-height: 180px;
                }
            }
            .c2 {
                color: #EFEA3C;
                font-size: 24px;
                margin: 40px 0;
            }
            .van-button {
                height: 65px;
                background: #FFF;
                border-color: #FFF;
                font-size: 32px;
                color: #009C90;
                font-family: "Microsoft YaHei", serif;
                padding: 15px 35px;
            }
        }
    }
    .top {
        width: 98%;
        height: 98%;
        background: url("../../assets/6.png") no-repeat center 30%;
        background-size: 80%;
        border: 1px solid #fff;
        margin: auto;
        .br {
            width: 60%;
            position: absolute;
            bottom: 25%;
            left: 20%;
            display: flex;
            flex-direction: row;
            justify-content: space-between;

            .van-field {
                width: 70%;
                height: 80px;
                font-size: 26px;
                line-height: 80px;
                text-align: center;
                color: #000;
                padding: 0;
                margin: 0 10px;
                border-radius: 20px;
                /deep/ .van-field__control {
                    text-align: center;
                }
            }

            .van-button {
                width: 80px;
                height: 80px;
                background: #FFF;
                border-color: #FFF;
                border-radius: 80px;
                font-size: 30px;
                padding: 0;
                color: #009C90;
            }
        }
        .bc {
            color: #EFEA3C;
            font-size: 26px;
            margin-top: 10px;
        }
    }
    .bottom {
        height: 60%;
        background: #009C90;
        padding: 2% 15px;
        .br {
            height: 100%;
            border: 2px solid #fff;
            position: relative;
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            & > span {
                display: block;
                font-size: 32px;
                padding-top: 20px;
                color: #fff;
            }

            .van-button {
                width: 480px;
                height: 130px;
                background: #fff;
                border-color: #fff;
                border-radius: 15px;
                font-size: 80px;
                letter-spacing: 3px;
                display: block;
                margin: auto;
                color: #e45a24;
                font-weight: bold;
            }

            .sp {
                color: #fff;
                font-size: 32px;
                margin-bottom: 20px;
                label {
                    font-size: 100px;
                    font-weight: bold;
                    margin: 0 30px;
                }
            }
            .van-image {
                width: 100%;
                height: 200px;
                text-align: center;
                /deep/ .van-image__img {
                    width: auto;
                    height: 100%;
                    margin: auto;
                }
            }
        }
    }

    .van-cell-group {
        background: none;
        padding: 10px 10px;
        position: relative;
        &:after {
            display: none;
        }
        .van-cell {
            background: none;
            border-bottom: 1px solid #EFEA3C;
            &:after {
                display: none;
            }
            .van-cell__value {
                color: #FFF100;
                text-align: center;
            }
            &:nth-child(1) {
                border-top: 1px solid #EFEA3C;
            }
        }
        .van-icon {
            position: absolute;
            right: 5px;
            top: 10px;
            background: #F8B62D;
            color: #ffffff;
            border-radius: 50%;
            font-size: 24px;
            padding: 3px;
        }
    }
    .van-address-list__bottom {
        background: none;
    }
    .van-field {
        margin: 0 150px;
        height: 90px;
        line-height: 60px;
        width: auto;
    }
    .select {
        background: #fff;
        margin: 0 30px;
        div {
            height: 60px;
            line-height: 60px;
            text-align: left;
            padding: 0 30px;
            span {
                font-size: 28px;
            }
            label {
                color: #969799;
                padding-left: 5px;
            }
        }
    }
}
</style>
